import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

import { ToastrService } from 'ngx-toastr';

import { UserPostsDataService } from '../../../services/posts.service';
import { ScoreService } from '../../../services/scores.service';
//import { PostMedia } from '../../interfaces/post-media.interface'; // Adjust the path as needed

import { GifModalComponent } from '../../../modals/gif-modal/gif-modal.component';

import *  as Classes from '../../../classes/models.classes'

@Component({
    selector: 'app-reply-submit',
    templateUrl: './reply-submit.component.html',
    styleUrls: ['./reply-submit.component.css']
})
export class ReplySubmitComponent implements OnInit {

    @Input() Username: string;
    @Input() UserID: number;
    @Input() OriginalPostID: number;
    @Input() ReplyPostID: number;
    @Input() PostUsername: number;
    @Input() pageType!: string; 

    @Output() postEditedOrDeleted = new EventEmitter<void>();

    UserPostsData: Array<Classes.ShortsPosts>;
    UserPostsDataContent: Classes.ShortsPostSave;

    currentPage = 1;
    pageSize = 10;
    isLoading = false;
    allPostsLoaded = false; // Flag to check if all posts are loaded

    selectedScoreTypeID: number | null = null;
    //selectedScoreTypeId: number | null = null;
    selectedScoreTypeIDs: { [key: number]: number } = {};
    showDetails: { [key: number]: boolean } = {};
    selectedScoreDetails: { [key: number]: Classes.ScoreDetails[] } = {};

    reactions: any = {};

    selectedFile: File | null = null;
    selectedFileUrl: string;

    selectedGifPreviewUrl: string;
    selectedGifAnimatedUrl: string;

    public replyType: number = 1; // Default to 'Everyone'
    replyTypes = [
        { id: 1, text: 'Everyone', icon: 'path/to/everyone.svg' },
        { id: 2, text: 'Accounts You Follow', icon: 'path/to/accounts-follow.svg' },
        { id: 3, text: 'Verified Accounts', icon: 'path/to/verified-accounts.svg' },
        { id: 4, text: 'Only Accounts You Mention', icon: 'path/to/accounts-mention.svg' }
    ];

    selectedReplyType = this.replyTypes[0];  // default to Everyone


    mediaUrls: any[] = [];  // This will include URLs, indexing, and any relevant flags

    activeIndex: number = 0;

    responsiveOptions: any[] = [
        {
            breakpoint: '1024px',
            numVisible: 3,
            numScroll: 1
        },
        {
            breakpoint: '768px',
            numVisible: 2,
            numScroll: 1
        },
        {
            breakpoint: '560px',
            numVisible: 1,
            numScroll: 1
        }
    ];

    constructor(
        private userPostsDataService: UserPostsDataService,
        private toastr: ToastrService,
        private route: ActivatedRoute,
        private modalService: NgbModal


    ) { }

    ngOnInit(): void {
        this.UserPostsData = new Array<Classes.ShortsPosts>();
        this.UserPostsDataContent = new Classes.ShortsPostSave();


    }

    saveReply(): void {

        this.UserPostsDataContent.UserID = this.UserID;
        this.UserPostsDataContent.OriginalPostID = this.OriginalPostID;
        this.UserPostsDataContent.ParentPostID = this.ReplyPostID;
        this.UserPostsDataContent.PostType = 4;
        this.UserPostsDataContent.PublishDate = new Date() // Date is set at the time of submission
        this.UserPostsDataContent.ReplyType = this.selectedReplyType.id; // Save replyType selection

        const formData = new FormData();

        formData.append('postData', JSON.stringify(this.UserPostsDataContent)); // Serialize your object into a JSON string

        // Add each media file or URL
        this.mediaUrls.forEach((mediaItem, index) => {
            if (!mediaItem.isTenor) {
                // Append local file
                formData.append(`file_${index}`, mediaItem.file!, mediaItem.file!.name);
                formData.append('mimeType', mediaItem.mimeType!);
            } else {
                // Append Tenor URL and Animated URL concatenated with a delimiter (e.g., `|`)
                const combinedUrl = `${mediaItem.url}|${mediaItem.animatedUrl}`;
                formData.append(`gifUrl_${index}`, combinedUrl);
            }
        });

        // Call service to save post
        this.userPostsDataService.saveReply(formData, this.UserID).subscribe({
            next: (response) => {
                //console.log('Post saved successfully', response);
                this.toastr.success('Reply saved successfully!');

                // Emit the event to refresh posts
                //this.postSaved.emit();

                // Reset post content and media URLs
                this.UserPostsDataContent.PostContent = '';
                this.mediaUrls = [];

                // Just refresh the posts
                this.refreshPosts();
            //    this.getUserPostsDataNew(true);
            },
            error: (error) => {
                //console.error('Error saving post', error);
                this.toastr.error('Error saving reply!');
            }
        });
    }

    openGifModal(): void {
        if (this.mediaUrls.length >= 4) return;
        const modalRef = this.modalService.open(GifModalComponent, { size: 'lg' });
        modalRef.componentInstance.gifSelected.subscribe((gifData: { previewUrl: string; animatedUrl: string }) => {
            // Set the URLs from the received object
            this.selectedGifPreviewUrl = gifData.previewUrl;
            this.selectedGifAnimatedUrl = gifData.animatedUrl;

            this.handleGifSelected(gifData);
        });
    }

    handleGifSelected(gifData: { previewUrl: string; animatedUrl: string }): void {
        const index = this.mediaUrls.length;
        const newItem = {
            url: gifData.previewUrl,
            isTenor: true,
            isPlaying: false,
            animatedUrl: gifData.animatedUrl,
            previewUrl: gifData.previewUrl,
            index: index  // Keeping track of item's index
        };
        this.mediaUrls.push(newItem);
    }

    setReplyType(replyType: any) {
        this.selectedReplyType = replyType;
    }

    adjustTextareaHeight(event: any): void {
        event.target.style.height = 'auto';
        event.target.style.height = event.target.scrollHeight + 'px';
    }

    triggerFileUpload(): void {
        document.getElementById('videoUpload')!.click();
    }

    checkVideo(event: any): void {
        this.selectedFile = event.target.files[0];

        if (!this.selectedFile) {
            return;
        }
        const mimeType = this.selectedFile.type; // Extract the MIME type

        // Clear the file input to allow re-upload of the same file if necessary
        event.target.value = '';

        // Handle video files separately
        if (this.selectedFile.type.startsWith('video/')) {
            // Check the file type
            if (this.selectedFile.type !== 'video/mp4' && this.selectedFile.type !== 'video/quicktime') {
                alert('Unsupported video format. Please upload a MP4 or MOV file.');
                return;
            }

            // Load the file into a video element to check duration
            const video = document.createElement('video');
            video.preload = 'metadata';

            video.onloadedmetadata = () => {
                window.URL.revokeObjectURL(video.src);
                const duration = video.duration;

                if (duration > 120) { // Check if video is longer than 2 minutes
                    alert('Video is too long. Maximum allowed duration is 2 minutes.');
                } else {
                    //alert('Video is valid. Duration: ' + duration + ' seconds.');

                    const index = this.mediaUrls.length; // Get the next index
                    const mediaItem = {
                        //url: URL.createObjectURL(this.selectedFile),
                        url: URL.createObjectURL(this.selectedFile),
                        file: this.selectedFile,
                        isVideo: true,
                        isTenor: false,  // Assuming you're handling only local files here
                        isPlaying: false,  // Not relevant for local files, but keeping the structure consistent
                        animatedUrl: null, // Not applicable for local files
                        previewUrl: null,   // For local files, the preview and actual URLs are the same
                        mimeType: mimeType, // Store the extracted MIME type
                        index: index       // Tracking the index of the new item
                    };

                    this.mediaUrls.push(mediaItem);
                    // Reset the file input
                    event.target.value = '';
                }
            };

            video.onerror = () => {
                alert('Unable to load the video for validation.');
            };
            video.src = URL.createObjectURL(this.selectedFile);

        } else if (this.selectedFile.type.startsWith('image/')) {
            // Handle image file (non-video)
            const reader = new FileReader();
            reader.onload = (e: any) => {
                //this.handleFileSelect(e.target.result);
                const index = this.mediaUrls.length; // Get the next index
                const mediaItem = {
                    url: URL.createObjectURL(this.selectedFile),
                    file: this.selectedFile,
                    isVideo: false,
                    isTenor: false,  // Assuming you're handling only local files here
                    isPlaying: false,  // Not relevant for local files, but keeping the structure consistent
                    animatedUrl: null, // Not applicable for local files
                    previewUrl: null,   // For local files, the preview and actual URLs are the same
                    mimeType: mimeType, // Store the extracted MIME type
                    index: index       // Tracking the index of the new item
                };

                this.mediaUrls.push(mediaItem);
                // Reset the file input
                event.target.value = '';


            };
            reader.readAsDataURL(this.selectedFile);
        }

    }


    // Toggle play/pause for GIF at specific index
    togglePlay(index: number): void {
        const item = this.mediaUrls[index];
        if (item.isTenor) {
            item.isPlaying = !item.isPlaying;
        }
    }

    removeMediaAtIndex(index: number): void {

        //console.log(`Deleting item at index ${index}`);  // Debugging output
        if (index > -1 && index < this.mediaUrls.length) {
            this.mediaUrls.splice(index, 1);
            this.mediaUrls = [...this.mediaUrls];  // Re-assign to trigger change detection
            //console.log(`Remaining items: ${this.mediaUrls.length}`);  // Check remaining items

            // After removing the item, check if the index is still valid
            if (index >= this.mediaUrls.length) {
                // If the index is out of bounds (e.g., last item was deleted), adjust it
                index = this.mediaUrls.length - 1;
            }

            // Manage focus after a slight delay to allow UI updates
            setTimeout(() => {
                this.focusOnCarouselItem(index);
            }, 100);
        }
    }

    focusOnCarouselItem(index: number): void {
        const carouselItemElements = document.querySelectorAll('.carousel-item-focusable');
        if (carouselItemElements[index]) {
            (carouselItemElements[index] as HTMLElement).focus();
        }
    }

    updateActiveIndex(event: any): void {
        //console.log(event);  // Log the entire event to see what properties are available
        this.activeIndex = event.page;  // Assuming 'page' is the correct property
    }


    refreshPosts() {
        // Emit the event to refresh posts
        this.postEditedOrDeleted.emit();
    }

}
